import { render } from "./Expectations.vue?vue&type=template&id=71fdcc92&scoped=true"
import script from "./Expectations.vue?vue&type=script&lang=js"
export * from "./Expectations.vue?vue&type=script&lang=js"

import "./Expectations.vue?vue&type=style&index=0&id=71fdcc92&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fdcc92"]])

export default __exports__